export default {
  data() {
    return {
      /**
      * Get/Set the saving state. Default: false
      * $root event network.error will reset it to false.
      */
      isSaving: false,
      /**
       * Get/Set the loading state of the table. Default: false
       * $root event network.error will reset it to false.
       */
      isLoading: false,
      /**
        * Collection of commonly used validation rules.
        */
    };
  },
  created() {
    this.$root.$on('network.error', () => {
      this.isSaving = false;
      this.isLoading = false;
    });
  },
  methods: {
    /**
     * Executes network request with loading state and try catch to $log.error
     */
    async networkLoad(asyncFunc, args) {
      try {
        this.isLoading = true;
        await asyncFunc(args);
      } catch (error) {
        this.$log.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
